import { useTranslation } from "react-i18next";
import { track } from "../../../shared/analytics/posthog";
import { APP_GOLD, APP_NAVY_GRADIENT, AppIcon, AppQr, StoreBadges } from "../../../shared/app-promo/app-promo-parts";

/**
 * The app on the homepage, just before the FAQ (owner picked the navy band,
 * 2026-10-15): the real app home screen in a phone frame, the store badges,
 * and on computers a QR. Only what the app really does: no ratings, no
 * discounts.
 */
export function AppSection() {
  const { t } = useTranslation();
  return (
    <section className="relative mx-auto w-full max-w-[1320px] px-4 py-3 sm:px-6 md:py-4 lg:px-8 lg:py-5" aria-labelledby="home-app-title">
      <div
        className="relative grid items-center gap-8 overflow-hidden rounded-[32px] p-6 text-white sm:p-8 md:grid-cols-[300px_minmax(0,1fr)] md:p-10 lg:grid-cols-[320px_minmax(0,1fr)]"
        style={{ background: APP_NAVY_GRADIENT }}
      >
        <div className="min-w-0 md:order-2">
          <div className="flex items-center gap-3">
            <AppIcon size={52} />
            <p className="text-[11px] font-bold uppercase tracking-[0.12em]" style={{ color: APP_GOLD }}>
              {t("app_promo.section_eyebrow")}
            </p>
          </div>
          <h2
            id="home-app-title"
            className="mt-4 text-balance text-[28px] font-semibold leading-tight md:text-[40px]"
            style={{ letterSpacing: "-0.03em" }}
          >
            {t("app_promo.section_title_start")}{" "}
            {/* Its own line on phones, so a short word never dangles at the end of the first. */}
            <span className="max-md:block" style={{ color: APP_GOLD }}>{t("app_promo.section_title_accent")}</span>
          </h2>
          <p className="mt-2 max-w-[44ch] text-pretty text-[15.5px] font-medium leading-relaxed" style={{ color: "rgba(255,255,255,0.8)" }}>
            {t("app_promo.section_sub")}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-4">
            <StoreBadges onPick={(store) => track("app_promo_store_click", { surface: "home_section", store })} />
            <div className="hidden md:block">
              <AppQr size={72} />
            </div>
          </div>
        </div>
        {/* The real app home screen (iPhone 17, 2026-10-15) in a plain frame. */}
        <div className="mx-auto w-[220px] md:order-1 md:w-[236px]">
          <div
            className="rounded-[44px] p-[7px]"
            style={{
              background: "linear-gradient(160deg,#3a3a46,#121218)",
              boxShadow: "0 0 0 1.5px rgba(255,255,255,0.18), 0 30px 60px -20px rgba(0,0,0,0.6)",
            }}
          >
            <img
              src="/images/app/home.webp"
              alt={t("app_promo.section_image_alt")}
              width={600}
              height={1305}
              loading="lazy"
              decoding="async"
              className="block h-auto w-full rounded-[37px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
